var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLikeIconFill = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.3772 6.78418C4.97942 6.78418 5.47451 7.24172 5.53442 7.82812L5.54126 7.94727V16.5586L5.53442 16.6777C5.47476 17.2644 4.97961 17.7227 4.3772 17.7227H2.46411C1.82162 17.7225 1.30005 17.2011 1.30005 16.5586V7.94727C1.30031 7.30496 1.82178 6.78434 2.46411 6.78418H4.3772Z",
    fill: "#6C7DE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3889 2C12.7003 2 13.4826 3.46156 12.7551 4.55273L10.9739 7.20117H17.3C18.057 7.20117 18.547 8.45218 18.3635 9.18652L16.8127 15.3916C16.4702 16.7613 15.2393 17.7226 13.8274 17.7227H10.3196C9.7123 17.7225 8.30005 17.5 8.30005 17.5L7.13306 17.2188C7.09019 17.1901 7.05957 17.1465 7.04712 17.0977L7.04126 17.0469V7.20117C7.04137 7.16541 7.04988 7.12968 7.06763 7.09863L10.553 2H11.3889Z",
    fill: "#6C7DE5"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLikeIconFill);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/likeIconFill.e05472ae4c71780887ef0f1061a8ea17.svg";